import Head from "next/head"
import React from "react"
import styled from "styled-components"

import { Container } from "~/components/Container"
import { Footer } from "~/components/Footer"
import { Header } from "~/components/Header"
import { Markdown } from "~/components/Markdown"
import { distributionTitle } from "~/config"
import { TrackingProvider } from "~/contexts/Tracking"
import { color } from "~/libs/style"
import { Notice } from "~/repository/NoticeCatalogsRepository"
// import { ToTopButton } from "../ToTopButton/ToTopButton"
type NoticeProps = {
  notice: Notice
  distribution: string
  configDomain: {
    top: string
    paid: string
    free: string
  }
}

export const FreeNotice: React.FC<NoticeProps> = (props) => {
  const { notice, configDomain } = props
  const title = distributionTitle
  return (
    <>
      <Head>
        <link rel="canonical" href={`/notices/${notice.id}.html`} />
        <title>{notice.title} - イージーゲーム|au Webポータル</title>
        <meta name="robots" content="noindex" />
        <meta name="description" content="イージーゲーム（簡単ゆる）お知らせ" />
        <meta name="apple-mobile-web-app-title" content="イージーゲーム（簡単ゆる）お知らせ" />
      </Head>
      <TrackingProvider categoryProp="お知らせ">
        <Container>
          <Header
            hasBackButton={true}
            backTitle={title}
            headerTitle={title}
            backUrl={configDomain.free}
            iconText="ポータルTOP"
          />

          <Headline>
            <TextGroup>
              <Title>{notice.title}</Title>
              <LastUpdate>{notice.lastUpdate}</LastUpdate>
            </TextGroup>
          </Headline>
          <Markdown source={notice.body} />
        </Container>
        <Footer />
        {/* <ToTopButton /> */}
      </TrackingProvider>
    </>
  )
}
const Headline = styled.div`
  margin-bottom: 10px;
  line-height: 1.3;
`

const TextGroup = styled.div`
  padding: 10px;
`

const Title = styled.h1`
  font-size: 18px;
  font-weight: bold;
`

const LastUpdate = styled.p`
  margin-top: 10px;
  color: ${color.silverGray};
  font-size: 12px;
  line-height: 1.2;
  text-align: right;
`
